module.exports = __webpack_public_path__ + "fonts/iconfont.996b54f.woff";